import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class FileService {

  constructor(private http: Http) { }

  getFiles(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/documents.json`, options)
      .map(res => res.json())
  }

  deleteFile(orgId: number, type: string) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/documents/delete_file.json?file_type=${type}`, options)
      .map(res => res.json())
  }


  downloadFile(orgId: number, type: string) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(`${environment.organizationsUrl}${orgId}/documents/download_file.json?file_type=${type}`, options)
      .map(res => res.blob())
  }

  getCsv(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(`${environment.csvUrl}/${orgId}.json`, options)
      .map(res => res.blob())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/file.service.ts